export type OnFetchFulfilledCallback = (response: Response) => Response | Promise<Response>;

/**
 * Mutable fetch interception state configured by `useFetchInterceptor` at runtime.
 * Lives in Services so fetch consumers do not depend on App-layer modules.
 */
export const fetchOptions: { interceptEnabled: boolean; onFetchCallback: OnFetchFulfilledCallback } = {
    interceptEnabled: false,
    onFetchCallback: (response: Response) => response,
};
